import { render } from "./Donate.vue?vue&type=template&id=b7c6540c&scoped=true&lang=pug"
import script from "./Donate.vue?vue&type=script&setup=true&lang=js"
export * from "./Donate.vue?vue&type=script&setup=true&lang=js"

import "./Donate.vue?vue&type=style&index=0&id=b7c6540c&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c6540c"]])

export default __exports__